import React from "react";
import { useTranslation } from "react-i18next";
import AppButton from "components/ui/AppButton";
import AppCollapse from "components/ui/AppCollapse";

function RefundButton({ status, setOpen }) {
  const { t } = useTranslation();
  const REFUND_STATUS = {
    COMPLETE: "COMPLETE",
    REQUESTED: "REQUESTED",
    FAILED: "FAILED",
  };
  const RefundButton = ({ title }) => (
    <>
      <div className="w-full py-3 hidden-print flex gap-2 items-center">
        <div className="text-gray-500">{t("Refund Details")}</div>
        <AppButton
          variant="primary"
          onClick={() => {
            setOpen(true);
          }}
        >
          {title}
        </AppButton>
      </div>
    </>
  );

  const getStatusText = () => {
    switch (status) {
      case REFUND_STATUS.COMPLETE:
        return t("Refund Completed");
      case REFUND_STATUS.REQUESTED:
        return t("Refund Requested");
      case REFUND_STATUS.FAILED:
        return t("Refund Failed");
      case "SUCCESS":
        return t("Refund Successfully");
      default:
        return null
    }
  }


  const statusText = React.useMemo(() => getStatusText(), [status]);

  return ( statusText ? 
  <AppCollapse title={t("Refund Information")} border={false}>
  <RefundButton title={statusText} /> </AppCollapse> : null )


}

export default RefundButton;
